import React, { FC, ReactNode } from 'react';
import { List, ListItem, ListSection } from 'snacks-design-system';
import style from './PIEList.module.scss';

interface IPIEListProps {
  children?: ReactNode;
  modBorder?: boolean;
  modCompact?: boolean;
  modColumns?: boolean;
  modRoleMenu?: boolean;
  qaSelector?: string;
}

interface IPIEListSectionProps {
  children?: ReactNode;
  modSectionDivider?: boolean;
}

interface IPIEListItemProps {
  children?: ReactNode;
  id?: string;
  labelId?: string;
  secondaryLabel?: ReactNode;
  secondaryLabelRigth?: ReactNode | string;
  metaLabel?: ReactNode;
  leading?: ReactNode | 'radio' | 'checkbox';
  trailing?: ReactNode | 'radio' | 'checkbox' | 'switch';
  left?: ReactNode | 'radio' | 'checkbox';
  right?: ReactNode | 'radio' | 'checkbox' | 'switch';
  role?: 'listitem' | 'option' | 'menuitem';
  isSelected?: boolean;
  isDisabled?: boolean;
  linkProps?: {
    href?: string;
    rel?: string;
    title?: string;
    target?: string;
    onClick?: () => void;
  };
  tabIndex?: number;
  modCompact?: boolean;
  borderStyle?: 'inherit' | 'none' | 'bottom';
  modSectionOffset?: boolean;
  modSectionDivider?: boolean;
  modAutoHeight?: boolean;
  onClick?: () => void;
  isLabelOnRight?: boolean;
}

type TPIEList = FC<IPIEListProps> & {
  Item: FC<IPIEListItemProps>;
  Section: FC<IPIEListSectionProps>;
};

const PIEListItem: FC = (props: IPIEListItemProps): JSX.Element => {
  return (
    <ListItem
      labelId="list-item-form-element_16"
      aria={{ label: `${props.isLabelOnRight ? 'custom-right' : 'custom'}` }}
      {...props}
    >
      {props.children}
    </ListItem>
  );
};

const PIEListSection: FC = (props: IPIEListSectionProps): JSX.Element => {
  return <ListSection {...props}>{props.children}</ListSection>;
};

export const PIEList: TPIEList = (props): JSX.Element => {
  return (
    <div className={style.container}>
      <List {...props}>{props.children}</List>
    </div>
  );
};

PIEList.Item = PIEListItem;
PIEList.Section = PIEListSection;

export default PIEList;
